
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockAddRemoveButtonComponent } from './block-add-remove-button.component';
import { DeleteConfirmationDialogModule } from './delete-confirmation-modal/delete-confirmation-dialog.module';
import { ErrorTracingModule } from 'libraries/service/error-tracing/error-tracing.module';
import { MatTableModule } from "@angular/material/table";
import { MatDialogModule } from "@angular/material/dialog";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        MatDialogModule,
        DeleteConfirmationDialogModule,
        ErrorTracingModule,
        FontAwesomeModule,
    ],
    declarations: [
        BlockAddRemoveButtonComponent,
    ],
    exports: [
        BlockAddRemoveButtonComponent,
    ],
})
export class BlockAddRemoveButtonModule { }
